import React, { Component } from 'react';

class Substitute extends Component {
  render() {

    const event = this.props.event;
    const place = this.props.place;

    // eslint-disable-next-line radix
    if( parseInt(event.team) !== parseInt(place) ) {
      return (
        <td colSpan="2" width="45%" className={"player" + place}>
        </td>
      )
    }

    const players = event.player.split('|');
    const eventCell = place === '1'

    ? (
      <td colSpan="2" width="45%" className={"substitute-players player" + place}>
        <span>
        <i className="fa fa-arrow-up green"></i>
        {players[0]}
        </span>
        <span className="out">
          <i className="fa fa-arrow-down red"></i>
          {players[1]}
        </span>
      </td>
    )
    : (
      <td colSpan="2" width="45%" className={"substitute-players player" + place}>
        <span className="out">
          {players[1]}
          <i className="fa fa-arrow-down red"></i>
        </span>
        <span>
        {players[0]}
        <i className="fa fa-arrow-up green"></i>
        </span>
      </td>
    );

    return eventCell;
  }
};

export default Substitute;


// WEBPACK FOOTER //
// ./src/Components/Substitute.js